import * as React from "react";

import { useQuery } from "@apollo/client";
import { GET_PANUI, PanuiQueryData } from "@plinknz/tah-website-elements";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { byPrefixAndName } from "@awesome.me/kit-d560caf08c/icons/modules";

import { Hero } from "./hero";

export interface PanuiNavigationProps {
  panuiDate: string;
}

export const PanuiNavigation = ({ panuiDate }: PanuiNavigationProps) => {
  const { data: dataPrev, error: errorPrev } = useQuery<PanuiQueryData>(
    GET_PANUI,
    {
      variables: {
        sort: "published_date:desc",
        filters: { published_date: { lt: panuiDate } },
        pagination: { limit: 1 },
      },
    }
  );

  const { data: dataNext, error: errorNext } = useQuery<PanuiQueryData>(
    GET_PANUI,
    {
      variables: {
        sort: "published_date:asc",
        filters: { published_date: { gt: panuiDate } },
        pagination: { limit: 1 },
      },
    }
  );

  if (!dataPrev || !dataNext) {
    return null;
  }

  const prevSlug = dataPrev.newsItems.length
    ? `/panui/${dataPrev.newsItems[0].slug}`
    : null;
  const nextSlug = dataNext.newsItems.length
    ? `/panui/${dataNext.newsItems[0].slug}`
    : null;

  if (!prevSlug && !nextSlug) {
    return null;
  }

  if (errorNext || errorPrev) {
    const error = errorNext || errorPrev;
    console.warn(error);
    const errorMessage = error?.graphQLErrors
      .map((graphqlError) =>
        graphqlError.extensions?.exception
          ? // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-member-access
            `${graphqlError.extensions.exception.output.statusCode} ${graphqlError.extensions.exception.message}`
          : null
      )
      .filter(Boolean)
      .join(", ");

    return (
      <Hero title="There was an unexpected error" subtitle={errorMessage} />
    );
  }

  return (
    <span className="menu-panui-navigation" data-testid="panui-navigation">
      {prevSlug && (
        <a href={prevSlug} className="menu-panui-navigation-link">
          <FontAwesomeIcon
            icon={byPrefixAndName.fas["chevron-left"]}
            className="footer-icon-inflate"
          />
          <span className="menu-panui-navigation-label">Mua</span>
        </a>
      )}
      {nextSlug && (
        <a href={nextSlug} className="menu-panui-navigation-link">
          <span className="menu-panui-navigation-label">Muri</span>
          <FontAwesomeIcon
            icon={byPrefixAndName.fas["chevron-right"]}
            className="footer-icon-inflate"
          />
        </a>
      )}
    </span>
  );
};
